import { InboxStateType } from '../Components/Notifications/notificationsTypes'
import { lddGlobalSessionInfo, NavObjectType } from '../Components/navigationTypes'
import { activityCenterObject } from '../fileToolbar/ActivityCenter/activityCenterTypes'
import { RightDrawerOption } from '../fileToolbar/fileToolbarTypes'
import Preference from '../lib/preference'
import { Package } from '../Components/DocMasters/types/Types' 
import { EsignAskfieldsItemProps } from '../Components/BuilderConnect/BuilderEsign/types'
import { TaskPreferenceItem } from '../../../libs/taskmanagement/src/taskTypes'
import { ThirdPartyListItem } from '../Components/ThirdPartyList/ThirdPartyTypes'

export type lddStateObject = {
    SessionID: string,
    SessionInfo: lddGlobalSessionInfo,
    currentNavigation: {
        livedataRootContainer: {
            dataRoot: Element
        },
        page: {
            component: string,
            params: Record<string, string>,
        }
    },
    ShowRenewSession: boolean,
    InternetDown: boolean,
    ThirdPartyListState:
    "showLawyerList" |
    "showFireInsuranceList" |
    "showRealEstateBrokerList" |
    "showPurchaserRealEstateBrokerList" |
    "showConveyancerList" |
    "showMortgageBrokerList" |
    "showMortgageLenderList" |
    "showOtherPartyList" |
    "showMortgageDropbox" |
    "showDRDisconnect" |
    "showLenderCentre"
    ,
    ThirdPartyListExtraPayload: Record<string, string>,
    ListData: {
        FormList: Array<any>,
        FileList: Array<any>,
        LawyerList: Array<any>,
        NotaryList: Array<any>,
        AllLawyerList: Array<any>,
        InsuranceList: Array<any>,
        RealEstateBrokerList: Array<any>,
        PurchaserRealEstateBrokerList: Array<any>,
        ConveyancerList: Array<any>,
        MortgageBrokerList: Array<any>,
        MortgageLenderList: Array<any>,
        MortgageLenderSelectFieldList: Array<any>,
        MortgageBranchList: Array<any>,
        LenderNames: Array<any>,
        DischargeLenderList: Array<any>,
        AllMortgageLenderList: Array<any>,
        OtherPartyList: Array<any>,
        SelectFileList: Array<any>,
        DRFileList: Array<any>,
        PackageList: Array<Package>,
        TaskList: Array<any>
    },
    ActivityCenter: activityCenterObject[],
    ActivityCenterUnread: number,
    ClientPortalState: {
        ModalType: string,
        PageName: string,
    }
    SideMenuReload: number, // use timestamp - new Date().getTime()
    InboxState: InboxStateType,
    ShowNotificationCentre: boolean,
    Preference: {
        PinRightSideTab: RightDrawerOption, // value "toggle" means no page is pinned
    },
    Indicators: {
        MyDriveHasNewDoc: boolean,
        Activity: boolean,
        IsPageDirty: boolean,
    },
    LenderVerified: boolean,
    ShowLenderCentre: boolean,
    ShowUserContactList: boolean,
    ShowEditFileNameWarning: boolean,
    ShowPackageSaveWarning: boolean,
    useSystemProvidedInfo: boolean,
    defaultUserInfo: boolean,
    ShowLenderCredentialsError: boolean,
    ShowChequePrinting: boolean,
    EditChequeDetails: boolean,
    EditChequeIndex: string,
    esignAskfieldsForm: EsignAskfieldsItemProps[],
    InFileTasks: any[],
    TaskPreferences: TaskPreferenceItem[],
    ProgressBarTask: any,
    DisplayToastMessage: {message: string, status: string} | null,
    SelectedLawyer: ThirdPartyListItem,
    SkipSetThirdPartyData: boolean,
    CreateFileFromAPS: boolean,
    CreateFileFromAPSUpload: boolean,
    RenAIMortgageSuccess: boolean,
    PropertyCoordinate: Record<string, number>,
    CalendarAppointment: any[],
    PortalScheduleMeeting: any,
    LastSaveTime: number,
}
export enum ReducerEnum {
    SET_SESSIONID = 1,
    SET_SESSIONINFO = 2,
    SET_NAVIGATION = 3,
    SET_ROOT = 4,
    SET_SHOWRENEWSESSION = 5,
    SET_INTERNETDOWN = 6,
    SET_LAWYERLIST = 7,
    SET_INSURANCEAGENT = 8,
    SET_REALESTATEBROKER = 9,
    SET_PURCHASERREALESTATEBROKER = 10,
    SET_CONVEYANCER = 11,
    SET_MORTGAGEBROKER = 12,
    SET_MORTGAGELENDER = 13,
    SET_LISTDATA = 14,
    SET_ACTIVITYCENTER = 15,
    SET_ACTIVITYCENTERADDNEW = 16,
    SET_ACTIVITYCENTERDELETE = 17,
    SET_THIRDPARTYLISTSTATE = 18,
    SET_OTHERPARTY = 19,
    SET_CLIENTPORTALSTATE = 20,
    SET_SIDEMENURELOAD = 21,
    SET_MORTGAGELENDERSELECTFIELD = 22,
    SET_FORMLISTDATA = 23,
    SET_INDICATORS = 24,
    SET_RESET_ACTIVITYCENTERUNREAD = 25,
    SET_PREFERENCE = 26,
    SET_LENDER_VERIFIED = 27,
    SET_SHOW_LENDER_CENTRE = 28,
    SET_INBOXACTION = 29,
    SET_SHOWNOTIFICATIONCENTRE = 30,
    SET_PROFILEPREFERENCE = 33,
    SET_LISTDEFAULT = 32,
    SET_SHOW_LENDER_CREDENTIALS_ERROR = 31,
    SET_SHOW_USER_CONTACT_LIST = 34,
    SET_ROOT_UNDEFINED = 35,
    SET_CHEQUE_PRINTING = 36,
    SET_EDIT_CHEQUE_DETAILS = 37,
    SET_EDIT_CHEQUE_INDEX = 38,
    SET_SHOW_EDIT_FILE_NAME_WARNING = 39,
    SET_ESIGN_ASKFIELDS_FORM = 40,
    SET_INFILE_TASKS = 41,
    SET_SHOW_PACKAGE_SAVE_WARNING = 42,
    SET_TASK_PREFERENCES = 43,
    SET_PROGRESS_BAR_TASK = 44,
    SET_DISPLAY_TOAST_MESSAGE = 45,
    CLEAR_DISPLAY_TOAST_MESSAGE = 46,
    SET_SELECTED_LAWYER = 47,
    SET_SKIP_SET_THIRDPARTY_DATA = 48,
    SET_CREATE_FILE_FROM_APS = 49,
    SET_CREATE_FILE_FROM_APS_UPLOAD = 50,
    SET_RENAI_MORTGAGE_SUCCESS = 51,
    SET_PROPERTY_COORDINATE = 52,
    SET_CALENDAR_APPOINTMENT = 53,
    SET_PORTAL_SCHEDULE_MEETING = 54,
    SET_LAST_SAVE_TIME = 55,
}

export type sessionIDActionType = {
    type: ReducerEnum,
    payload: any,
    key?: string,
    extraPayload?: Record<string, string>,
}

export function sessionIDReducer(state: lddStateObject, action: sessionIDActionType) {
    switch (action.type) {
        case ReducerEnum.SET_SESSIONID:
            return {
                ...state,
                SessionID: action.payload
            }
        case ReducerEnum.SET_SHOWRENEWSESSION:
            return {
                ...state,
                ShowRenewSession: action.payload
            }
        case ReducerEnum.SET_INTERNETDOWN:
            return {
                ...state,
                InternetDown: action.payload
            }
        case ReducerEnum.SET_SESSIONINFO:
            return {
                ...state,
                SessionInfo: action.payload
            }
        case ReducerEnum.SET_NAVIGATION:
            return {
                ...state,
                currentNavigation: {
                    ...state.currentNavigation,
                    page: action.payload,
                }
            }
        case ReducerEnum.SET_ROOT:
            if (action.payload) {
                return {
                    ...state,
                    currentNavigation: {
                        ...state.currentNavigation,
                        livedataRootContainer: { dataRoot: action.payload }
                    }
                }
            }
            return state
        case ReducerEnum.SET_ROOT_UNDEFINED:
            return {
                ...state,
                currentNavigation: {
                    ...state.currentNavigation,
                    livedataRootContainer: { dataRoot: undefined }
                }
            }
        case ReducerEnum.SET_LAWYERLIST:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showLawyerList'
                }
            }
            return state
        case ReducerEnum.SET_INSURANCEAGENT:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showInsuranceList',
                }
            }
            return state
        case ReducerEnum.SET_REALESTATEBROKER:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showRealEstateBrokerList',
                }
            }
            return state
        case ReducerEnum.SET_OTHERPARTY:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showOtherPartyList',
                }
            }
            return state
        case ReducerEnum.SET_PURCHASERREALESTATEBROKER:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showPurchaserRealEstateBrokerList',
                }
            }
            return state
        case ReducerEnum.SET_CONVEYANCER:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showConveyancerList',
                }
            }
            return state
        case ReducerEnum.SET_MORTGAGEBROKER:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showMortgageBrokerList',
                }
            }
            return state
        case ReducerEnum.SET_MORTGAGELENDER:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showMortgageLenderList',
                }
            }
            return state
        case ReducerEnum.SET_MORTGAGELENDERSELECTFIELD:
            if (action.type) {
                return {
                    ...state,
                    ThirdPartyListState: 'showMortgageLenderSelectFieldList',
                }
            }
            return state
        case ReducerEnum.SET_LISTDATA:
            const newState = {
                ...state,
                ListData: {
                    ...state.ListData
                }
            }
            newState.ListData[action.key] = action.payload;
            return newState;
        case ReducerEnum.SET_ACTIVITYCENTER:
            return {
                ...state,
                ActivityCenter: [...action.payload]
            };
        case ReducerEnum.SET_ACTIVITYCENTERADDNEW: {
            const newState = {
                ...state,
                ActivityCenter: [action.payload, ...state.ActivityCenter],
                ActivityCenterUnread: state.ActivityCenterUnread + 1,
                Indicators: {
                    ...state.Indicators
                }
            }
            newState.Indicators["Activity"] = true;
            return newState;
        }
        case ReducerEnum.SET_ACTIVITYCENTERDELETE:
            const tempActivityCenter = [...state.ActivityCenter];
            let tempActivityCenterUnread = state.ActivityCenterUnread;
            if (tempActivityCenter.length > 0) {
                if (action.payload as number | string === -1) { // remove last
                    tempActivityCenter.splice(0, 1);
                    if (tempActivityCenterUnread > 0) tempActivityCenterUnread--;
                } else {
                    for (let i = 0; i < tempActivityCenter.length; i++) {
                        if (tempActivityCenter[i].index &&
                            tempActivityCenter[i].index === action.payload as number | string) {
                            tempActivityCenter.splice(i, 1);
                            if (tempActivityCenterUnread > 0) tempActivityCenterUnread--;
                            break;
                        }
                    }
                }
            }

            return {
                ...state,
                ActivityCenter: [...tempActivityCenter],
                ActivityCenterUnread: tempActivityCenterUnread,
                Indicators: {
                    ...state.Indicators,
                    Activity: tempActivityCenterUnread > 0
                }
            };
        case ReducerEnum.SET_RESET_ACTIVITYCENTERUNREAD:
            return {
                ...state,
                ActivityCenterUnread: 0
            }
        case ReducerEnum.SET_THIRDPARTYLISTSTATE:
            return {
                ...state,
                ThirdPartyListState: action.payload,
                ThirdPartyListExtraPayload: action.extraPayload
            }
        case ReducerEnum.SET_CLIENTPORTALSTATE:
            return {
                ...state,
                ClientPortalState: {
                    ...state.ClientPortalState,
                    ...action.payload,
                }
            }
        case ReducerEnum.SET_SIDEMENURELOAD:
            return {
                ...state,
                SideMenuReload: action.payload
            }
        case ReducerEnum.SET_FORMLISTDATA:
            const newFormDataState = {
                ...state,
                ListData: {
                    ...state.ListData
                }
            }
            newFormDataState.ListData[action.key] = action.payload;
            return newFormDataState;
        case ReducerEnum.SET_INBOXACTION:
            return {
                ...state,
                InboxState: action.payload
            }
        case ReducerEnum.SET_SHOWNOTIFICATIONCENTRE:
            return {
                ...state,
                ShowNotificationCentre: action.payload
            }
        case ReducerEnum.SET_PREFERENCE: {
            const newState = {
                ...state,
                Preference: {
                    ...state.Preference
                }
            }
            newState.Preference[action.key] = action.payload;
            Preference.set(newState.Preference, newState.SessionInfo);
            return newState;
        }
        case ReducerEnum.SET_INDICATORS: {
            const newState = {
                ...state,
                Indicators: {
                    ...state.Indicators
                }
            }
            newState.Indicators[action.key] = action.payload
            return newState;
        }
        case ReducerEnum.SET_LENDER_VERIFIED:
            return {
                ...state,
                LenderVerified: action.payload
            }
        case ReducerEnum.SET_SHOW_LENDER_CENTRE:
            return {
                ...state,
                ShowLenderCentre: action.payload
            }
        case ReducerEnum.SET_PROFILEPREFERENCE: {
            const newState = {
                ...state,
                useSystemProvidedInfo : action.payload
            }
            return newState;
        }
        case ReducerEnum.SET_LISTDEFAULT: {
            const newState = {
                ...state,
                defaultUserInfo: action.payload
            }
            return newState;
        }
        case ReducerEnum.SET_SHOW_USER_CONTACT_LIST:
            return {
                ...state,
                ShowUserContactList: action.payload
            }
        case ReducerEnum.SET_CHEQUE_PRINTING:
            return {
                ...state,
                ShowChequePrinting: action.payload
            }
        case ReducerEnum.SET_DISPLAY_TOAST_MESSAGE:
            return {
                ...state,
                DisplayToastMessage: action.payload
            }
        case ReducerEnum.SET_EDIT_CHEQUE_DETAILS:
            return {
                ...state,
                EditChequeDetails: action.payload
            }
        case ReducerEnum.SET_EDIT_CHEQUE_INDEX:
            return {
                ...state,
                EditChequeIndex: action.payload
            }
        case ReducerEnum.SET_SHOW_EDIT_FILE_NAME_WARNING:
            return {
                ...state,
                ShowEditFileNameWarning: action.payload
            }
        case ReducerEnum.SET_SHOW_PACKAGE_SAVE_WARNING:
            return {
                ...state,
                ShowPackageSaveWarning: action.payload
            }
        case ReducerEnum.SET_ESIGN_ASKFIELDS_FORM:
            return {
                ...state,
                esignAskfieldsForm: action.payload
            }
        case ReducerEnum.SET_INFILE_TASKS:
            return {
                ...state,
                InFileTasks: action.payload
            }
        case ReducerEnum.SET_TASK_PREFERENCES:
            return {
                ...state,
                TaskPreferences: action.payload
            }
        case ReducerEnum.SET_PROGRESS_BAR_TASK:
            return {
                ...state,
                ProgressBarTask: action.payload
            }
        case ReducerEnum.CLEAR_DISPLAY_TOAST_MESSAGE:
            return {
                ...state,
                DisplayToastMessage: null
            }
        case ReducerEnum.SET_SELECTED_LAWYER:
            return {
                ...state,
                SelectedLawyer: action.payload
            }
        case ReducerEnum.SET_SKIP_SET_THIRDPARTY_DATA:
            return {
                ...state,
                SkipSetThirdPartyData: action.payload
            }
        case ReducerEnum.SET_CREATE_FILE_FROM_APS:
            return {
                ...state,
                CreateFileFromAPS: action.payload
            }
        case ReducerEnum.SET_CREATE_FILE_FROM_APS_UPLOAD:
            return {
                ...state,
                CreateFileFromAPSUpload: action.payload
            }
        case ReducerEnum.SET_RENAI_MORTGAGE_SUCCESS:
            return {
                ...state,
                RenAIMortgageSuccess: action.payload
            }
        case ReducerEnum.SET_PROPERTY_COORDINATE:
            return {
                ...state,
                PropertyCoordinate: action.payload
            }
        case ReducerEnum.SET_CALENDAR_APPOINTMENT:
            return {
                ...state,
                CalendarAppointment: action.payload
            }
        case ReducerEnum.SET_PORTAL_SCHEDULE_MEETING:
            return {
                ...state,
                PortalScheduleMeeting: action.payload
            }
        case ReducerEnum.SET_LAST_SAVE_TIME:
            return {
                ...state,
                LastSaveTime: action.payload
            }
        default:
            return state;
    }
}

export function setNavURL(url: string) {
    const [file, paramStr] = url.split("?");
    let page: NavObjectType;
    if (paramStr) {
        const searchParams = new URLSearchParams(paramStr)
        page = { component: 'main', url: file, params: Object.fromEntries(searchParams) }
    } else {
        page = { component: 'main', url: file }
    }
    setNavigation(page)
}
export function setRoot(dataRoot: Element) {
    return {
        type: ReducerEnum.SET_ROOT,
        payload: dataRoot,
    }
}
export function setRootUndef() {
    return {
        type: ReducerEnum.SET_ROOT_UNDEFINED
    }
}
export function setShowRenewSession(flag: boolean) {
    return {
        type: ReducerEnum.SET_SHOWRENEWSESSION,
        payload: flag,
    }
}

export function setInternetDown(flag: boolean) {
    return {
        type: ReducerEnum.SET_INTERNETDOWN,
        payload: flag,
    }
}
export function setNavigation(navigation: NavObjectType) {
    return {
        type: ReducerEnum.SET_NAVIGATION,
        payload: navigation,
    }
}

export function setSessionState(id: string): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SESSIONID,
        payload: id
    }
}

export function setSessionInfo(info: lddGlobalSessionInfo): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SESSIONINFO,
        payload: info
    }
}
export function setLenderVerified(isVerified: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_LENDER_VERIFIED,
        payload: isVerified
    }
}

export function setShowLenderCentre(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SHOW_LENDER_CENTRE,
        payload: show
    }
}
export function setShowUserContactList(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SHOW_USER_CONTACT_LIST,
        payload: show
    }
}

export function setShowChequePrinting(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CHEQUE_PRINTING,
        payload: show
    }
}

export function setDisplayToastMessage(message: string, status: string): sessionIDActionType {
    return {
        type: ReducerEnum.SET_DISPLAY_TOAST_MESSAGE,
        payload: {
            message: message,
            status: status
        }
    }
}

export function setEditChequeDetails(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_EDIT_CHEQUE_DETAILS,
        payload: show
    }
}

export function setEditChequeIndex(index: string): sessionIDActionType {
    return {
        type: ReducerEnum.SET_EDIT_CHEQUE_INDEX,
        payload: index
    }
}

export function setPropertyCoordinate(coordinate: string): sessionIDActionType {
    const coordStr = coordinate.replace(/[()]/g, "");
    const [latStr, lngStr] = coordStr.split(",").map(s => s.trim());
    const coord = {"lat": parseFloat(latStr), "lng":parseFloat(lngStr)}
    return {
        type: ReducerEnum.SET_PROPERTY_COORDINATE,
        payload: coord
    }
}

export function setShowLenderCredentialsError(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SHOW_LENDER_CREDENTIALS_ERROR,
        payload: show
    }
}

export function setShowEditFileNumberWarning(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SHOW_EDIT_FILE_NAME_WARNING,
        payload: show
    }
}

export function setShowPackageSaveWarning(show: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SHOW_PACKAGE_SAVE_WARNING,
        payload: show
    }
}
export function setEsignAskfieldsForm(form: EsignAskfieldsItemProps[]): sessionIDActionType {
    return {
        type: ReducerEnum.SET_ESIGN_ASKFIELDS_FORM,
        payload: form
    }
}

export function setInfileTasks(tasks: any[]): sessionIDActionType {
    return {
        type: ReducerEnum.SET_INFILE_TASKS,
        payload: tasks
    }
}

export function setTaskPreferences(preferences: TaskPreferenceItem[]): sessionIDActionType {
    return {
        type: ReducerEnum.SET_TASK_PREFERENCES,
        payload: preferences
    }
}
export function setLawyerListState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showLawyerList' : '')
}

export function setFireInsuranceAgentState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showInsuranceList' : '')
}

export function setRealEstateBrokerState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showRealEstateBrokerList' : '')
}

export function setOtherPartyState(flag: boolean, extraPayload: Record<string, string>) {
    return setThirdPartyListState(flag ? 'showOtherPartyList' : '', extraPayload)
}

export function setPurchaserRealEstateBrokerState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showPurchaserRealEstateBrokerList' : '')
}

export function setSelectFileListState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showSelectFileList' : '')
}

export function setDRFileListState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showDRFileList' : '')
}

export function setThirdPartyListState(state: string, extraPayload?: Record<string, string>) {
    return {
        type: ReducerEnum.SET_THIRDPARTYLISTSTATE,
        payload: state,
        extraPayload: extraPayload,
    }
}

export function setConveyancerState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showConveyancerList' : '')
}

export function setMortgageBrokerState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showMortgageBrokerList' : '')
}

export function setMortgageLenderState(flag: boolean) {
    return setThirdPartyListState(flag ? 'showMortgageLenderList' : '')
}

export function setListDataState(stateName: string, data): sessionIDActionType {
    return {
        type: ReducerEnum.SET_LISTDATA,
        payload: data,
        key: stateName
    }
}

export function setFormListDataState(stateName: string, data): sessionIDActionType {
    return {
        type: ReducerEnum.SET_FORMLISTDATA,
        payload: data,
        key: stateName
    }
}

export function setActivityCenter(activityCenterObj: activityCenterObject[]): sessionIDActionType {
    return {
        type: ReducerEnum.SET_ACTIVITYCENTER,
        payload: activityCenterObj,
    }
}

export function setActivityCenterAddNew(newMessage: activityCenterObject): sessionIDActionType {
    return {
        type: ReducerEnum.SET_ACTIVITYCENTERADDNEW,
        payload: newMessage,
    }
}

export function setActivityCenterDelete(tracker: number | string): sessionIDActionType {
    return {
        type: ReducerEnum.SET_ACTIVITYCENTERDELETE,
        payload: tracker,
    }
}

export function setClientPortalModalType(modalType): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CLIENTPORTALSTATE,
        payload: {
            ModalType: modalType,
        }
    }
}

export function setProfilePreferences(payload): sessionIDActionType {
    return {
        type: ReducerEnum.SET_PROFILEPREFERENCE,
        payload: payload

    }
}
export function setClientPortalPage(pageName): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CLIENTPORTALSTATE,
        payload: {
            PageName: pageName
        }
    }
}

export function setPreference<T extends keyof lddStateObject["Preference"]>(
    key: keyof lddStateObject["Preference"],
    option: lddStateObject["Preference"][T]
) {
    return {
        type: ReducerEnum.SET_PREFERENCE,
        key: key,
        payload: option
    }
}

export function setIndicators(actionKey: keyof lddStateObject["Indicators"], payload: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_INDICATORS,
        key: actionKey,
        payload: payload
    }
}

export function setInboxState(actionType: boolean, args?: any, esign?: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_INBOXACTION,
        payload: {
            action: actionType,
            esign: esign,
            args: args
        }
    }
}

export function setDefaultListInfo(flag: boolean) {
    return {
        type: ReducerEnum.SET_LISTDEFAULT,
        payload: {
            action: flag
        }
    }
}

export function setShowNotificationCentre(flag: boolean) {
    return {
        type: ReducerEnum.SET_SHOWNOTIFICATIONCENTRE,
        payload: flag,
    }
}

export function setProgressBarTask(task: any): sessionIDActionType {
    return {
        type: ReducerEnum.SET_PROGRESS_BAR_TASK,
        payload: task
    }
}

export function clearDisplayToastMessage(): sessionIDActionType {
    return {
        type: ReducerEnum.CLEAR_DISPLAY_TOAST_MESSAGE,
        payload: null
    }
}

export function setSelectedLawyer(lawyer: ThirdPartyListItem): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SELECTED_LAWYER,
        payload: lawyer
    }
}

export function setSkipSetThirdPartyData(flag: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_SKIP_SET_THIRDPARTY_DATA,
        payload: flag
    }
}

export function setCreateFileFromAPS(flag: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CREATE_FILE_FROM_APS,
        payload: flag
    }
}

export function setCreateFileFromAPSUpload(flag: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CREATE_FILE_FROM_APS_UPLOAD,
        payload: flag
    }
}

export function setRenAIMortgageSuccess(flag: boolean): sessionIDActionType {
    return {
        type: ReducerEnum.SET_RENAI_MORTGAGE_SUCCESS,
        payload: flag
    }
}

export function setCalendarAppointment(appointment: any): sessionIDActionType {
    return {
        type: ReducerEnum.SET_CALENDAR_APPOINTMENT,
        payload: appointment
    }
}

export function setPortalScheduleMeeting(meeting: any): sessionIDActionType {
    return {
        type: ReducerEnum.SET_PORTAL_SCHEDULE_MEETING,
        payload: meeting
    }
}

export function setLastSaveTime(time: number): sessionIDActionType {
    return {
        type: ReducerEnum.SET_LAST_SAVE_TIME,
        payload: time
    }
}